import React, { Component } from 'react';
import { Button } from './ui/Button';
import { CheckCircleIcon, XCircleIcon, AlertTriangleIcon, BatteryChargingIcon, WifiIcon, BluetoothIcon, SpeakerIcon, CameraIcon, SmartphoneIcon, CheckIcon, ZapIcon, ShieldIcon } from 'lucide-react';
export function DiagnosticPlatform() {
  return <section id="demo" className="bg-gray-50 dark:bg-black text-gray-900 dark:text-white py-20" data-id="element-404">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-405">
        <div className="text-center mb-8" data-id="element-406">
          <div className="inline-block px-6 py-2 bg-blue-50 dark:bg-brand-green/10 rounded-full text-blue-600 dark:text-brand-green font-medium mb-4" data-id="element-407">
            See CH3CKTECH in action
          </div>
          <p className="text-gray-600 dark:text-gray-400 max-w-3xl mx-auto" data-id="element-408">
            Our comprehensive diagnostic platform provides detailed device
            information, IMEI verification, and component testing to ensure
            every device is properly evaluated.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center mt-16" data-id="element-409">
          <div className="relative" data-id="element-410">
            <div className="rounded-lg overflow-hidden shadow-lg bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800" data-id="element-411">
              <div className="p-4 border-b border-gray-200 dark:border-gray-800" data-id="element-412">
                <div className="flex justify-between items-center" data-id="element-413">
                  <div className="flex items-center" data-id="element-414">
                    <div className="h-10 w-10 bg-blue-100 dark:bg-brand-green/10 rounded-full flex items-center justify-center mr-3" data-id="element-415">
                      <SmartphoneIcon className="h-5 w-5 text-blue-600 dark:text-brand-green" data-id="element-416" />
                    </div>
                    <div data-id="element-417">
                      <h3 className="font-medium text-gray-900 dark:text-white" data-id="element-418">
                        CH3CKTECH Platform
                      </h3>
                      <p className="text-sm text-gray-500 dark:text-gray-400" data-id="element-419">
                        Device Assessment Tool
                      </p>
                    </div>
                  </div>
                  <div className="flex space-x-2" data-id="element-420">
                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 dark:bg-brand-green/10 text-blue-800 dark:text-brand-green" data-id="element-421">
                      iPhone 13 Pro
                    </span>
                  </div>
                </div>
              </div>
              <div className="p-6" data-id="element-422">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6" data-id="element-423">
                  <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-4" data-id="element-424">
                    <h4 className="text-gray-700 dark:text-gray-300 text-sm mb-2 font-medium" data-id="element-425">
                      Device Information
                    </h4>
                    <div className="space-y-2" data-id="element-426">
                      <div className="flex justify-between" data-id="element-427">
                        <span className="text-gray-500 dark:text-gray-400" data-id="element-428">
                          Model
                        </span>
                        <span className="text-gray-900 dark:text-white font-medium" data-id="element-429">
                          iPhone 13 Pro
                        </span>
                      </div>
                      <div className="flex justify-between" data-id="element-430">
                        <span className="text-gray-500 dark:text-gray-400" data-id="element-431">
                          Storage
                        </span>
                        <span className="text-gray-900 dark:text-white font-medium" data-id="element-432">
                          128GB
                        </span>
                      </div>
                      <div className="flex justify-between" data-id="element-433">
                        <span className="text-gray-500 dark:text-gray-400" data-id="element-434">
                          Color
                        </span>
                        <span className="text-gray-900 dark:text-white font-medium" data-id="element-435">
                          Graphite
                        </span>
                      </div>
                      <div className="flex justify-between" data-id="element-436">
                        <span className="text-gray-500 dark:text-gray-400" data-id="element-437">
                          IMEI
                        </span>
                        <span className="text-gray-900 dark:text-white font-medium" data-id="element-438">
                          3549*******12
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-4" data-id="element-439">
                    <h4 className="text-gray-700 dark:text-gray-300 text-sm mb-2 font-medium" data-id="element-440">
                      IMEI Verification
                    </h4>
                    <div className="space-y-2" data-id="element-441">
                      <div className="flex items-center" data-id="element-442">
                        <CheckCircleIcon className="h-4 w-4 text-green-500 mr-2" data-id="element-443" />
                        <span className="text-gray-700 dark:text-gray-300" data-id="element-444">
                          Clean Status
                        </span>
                      </div>
                      <div className="flex items-center" data-id="element-445">
                        <CheckCircleIcon className="h-4 w-4 text-green-500 mr-2" data-id="element-446" />
                        <span className="text-gray-700 dark:text-gray-300" data-id="element-447">
                          Not Blacklisted
                        </span>
                      </div>
                      <div className="flex items-center" data-id="element-448">
                        <CheckCircleIcon className="h-4 w-4 text-green-500 mr-2" data-id="element-449" />
                        <span className="text-gray-700 dark:text-gray-300" data-id="element-450">
                          Not Reported Lost
                        </span>
                      </div>
                      <div className="flex items-center" data-id="element-451">
                        <ShieldIcon className="h-4 w-4 text-blue-600 dark:text-brand-green mr-2" data-id="element-452" />
                        <span className="text-gray-700 dark:text-gray-300" data-id="element-453">
                          Verification Complete
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-4 mb-6" data-id="element-454">
                  <h4 className="text-gray-700 dark:text-gray-300 text-sm mb-3 font-medium" data-id="element-455">
                    Component Testing
                  </h4>
                  <div className="grid grid-cols-2 sm:grid-cols-4 gap-3" data-id="element-456">
                    <ComponentStatus icon={<BatteryChargingIcon className="h-5 w-5" data-id="element-458" />} name="Battery" status="passed" detail="86%" data-id="element-457" />
                    <ComponentStatus icon={<CameraIcon className="h-5 w-5" data-id="element-460" />} name="Camera" status="passed" data-id="element-459" />
                    <ComponentStatus icon={<WifiIcon className="h-5 w-5" data-id="element-462" />} name="WiFi" status="passed" data-id="element-461" />
                    <ComponentStatus icon={<BluetoothIcon className="h-5 w-5" data-id="element-464" />} name="Bluetooth" status="passed" data-id="element-463" />
                    <ComponentStatus icon={<SpeakerIcon className="h-5 w-5" data-id="element-466" />} name="Speakers" status="warning" detail="Low volume" data-id="element-465" />
                    <ComponentStatus icon={<ZapIcon className="h-5 w-5" data-id="element-468" />} name="Charging" status="passed" data-id="element-467" />
                    <ComponentStatus icon={<SmartphoneIcon className="h-5 w-5" data-id="element-470" />} name="Screen" status="passed" data-id="element-469" />
                    <ComponentStatus icon={<div className="i-lucide-vibrate h-5 w-5" data-id="element-472" />} name="Vibration" status="failed" data-id="element-471" />
                  </div>
                </div>
                <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-4" data-id="element-473">
                  <h4 className="text-gray-700 dark:text-gray-300 text-sm mb-3 font-medium" data-id="element-474">
                    Physical Condition
                  </h4>
                  <div className="flex items-center justify-between mb-2" data-id="element-475">
                    <span className="text-gray-500 dark:text-gray-400" data-id="element-476">
                      Overall Grade
                    </span>
                    <span className="text-gray-900 dark:text-white font-medium" data-id="element-477">
                      Good
                    </span>
                  </div>
                  <div className="mb-4" data-id="element-478">
                    <div className="h-2 bg-gray-200 rounded-full" data-id="element-479">
                      <div className="h-full bg-blue-500 rounded-full" style={{
                      width: '70%'
                    }} data-id="element-480"></div>
                    </div>
                  </div>
                  <div className="space-y-2 text-sm" data-id="element-481">
                    <div className="flex items-start" data-id="element-482">
                      <CheckCircleIcon className="h-4 w-4 text-green-500 mr-2 mt-0.5" data-id="element-483" />
                      <span className="text-gray-700" data-id="element-484">
                        Minor scratches on back panel
                      </span>
                    </div>
                    <div className="flex items-start" data-id="element-485">
                      <AlertTriangleIcon className="h-4 w-4 text-yellow-500 mr-2 mt-0.5" data-id="element-486" />
                      <span className="text-gray-700" data-id="element-487">
                        Small dent on bottom edge
                      </span>
                    </div>
                    <div className="flex items-start" data-id="element-488">
                      <CheckCircleIcon className="h-4 w-4 text-green-500 mr-2 mt-0.5" data-id="element-489" />
                      <span className="text-gray-700" data-id="element-490">
                        Screen in excellent condition
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-white dark:bg-gray-900 p-10 rounded-lg shadow-md border border-gray-200 dark:border-gray-800" data-id="element-491">
            <h2 className="text-2xl font-bold mb-4 text-gray-900 dark:text-white" data-id="element-492">
              AI-Powered Device Assessment
            </h2>
            <p className="text-gray-600 dark:text-gray-400 mb-8" data-id="element-493">
              Our advanced AI technology accurately evaluates device condition,
              ensuring fair and competitive trade-in values.
            </p>
            <div className="space-y-4" data-id="element-494">
              <div className="flex items-start" data-id="element-495">
                <div className="flex-shrink-0 mt-1" data-id="element-496">
                  <CheckCircleIcon className="h-5 w-5 text-blue-600 dark:text-brand-green" data-id="element-497" />
                </div>
                <p className="ml-3 text-gray-700 dark:text-gray-300" data-id="element-498">
                  Visual inspection detects scratches, dents, and screen damage
                </p>
              </div>
              <div className="flex items-start" data-id="element-499">
                <div className="flex-shrink-0 mt-1" data-id="element-500">
                  <CheckCircleIcon className="h-5 w-5 text-blue-600 dark:text-brand-green" data-id="element-501" />
                </div>
                <p className="ml-3 text-gray-700 dark:text-gray-300" data-id="element-502">
                  Functional testing for all device components
                </p>
              </div>
              <div className="flex items-start" data-id="element-503">
                <div className="flex-shrink-0 mt-1" data-id="element-504">
                  <CheckCircleIcon className="h-5 w-5 text-blue-600 dark:text-brand-green" data-id="element-505" />
                </div>
                <p className="ml-3 text-gray-700 dark:text-gray-300" data-id="element-506">
                  Market-based pricing algorithms for maximum value
                </p>
              </div>
              <div className="flex items-start" data-id="element-507">
                <div className="flex-shrink-0 mt-1" data-id="element-508">
                  <CheckCircleIcon className="h-5 w-5 text-blue-600 dark:text-brand-green" data-id="element-509" />
                </div>
                <p className="ml-3 text-gray-700 dark:text-gray-300" data-id="element-510">
                  Instant quotes in under 2 minutes
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-16" data-id="element-511">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-512">
            <div className="bg-white dark:bg-gray-900 p-10 rounded-lg shadow-md border border-gray-200 dark:border-gray-800" data-id="element-513">
              <h2 className="text-2xl font-bold mb-4 text-gray-900 dark:text-white" data-id="element-514">
                Seamless Trade-In Experience
              </h2>
              <p className="text-gray-600 dark:text-gray-400 mb-8" data-id="element-515">
                From quote to payment, our platform ensures a smooth and
                transparent process for both consumers and businesses.
              </p>
              <div className="space-y-4" data-id="element-516">
                <div className="flex items-start" data-id="element-517">
                  <div className="flex-shrink-0 mt-1" data-id="element-518">
                    <CheckCircleIcon className="h-5 w-5 text-blue-600 dark:text-brand-green" data-id="element-519" />
                  </div>
                  <p className="ml-3 text-gray-700 dark:text-gray-300" data-id="element-520">
                    Free shipping with prepaid labels
                  </p>
                </div>
                <div className="flex items-start" data-id="element-521">
                  <div className="flex-shrink-0 mt-1" data-id="element-522">
                    <CheckCircleIcon className="h-5 w-5 text-blue-600 dark:text-brand-green" data-id="element-523" />
                  </div>
                  <p className="ml-3 text-gray-700 dark:text-gray-300" data-id="element-524">
                    Secure data wiping on all devices
                  </p>
                </div>
                <div className="flex items-start" data-id="element-525">
                  <div className="flex-shrink-0 mt-1" data-id="element-526">
                    <CheckCircleIcon className="h-5 w-5 text-blue-600 dark:text-brand-green" data-id="element-527" />
                  </div>
                  <p className="ml-3 text-gray-700 dark:text-gray-300" data-id="element-528">
                    Fast payment processing within 24 hours
                  </p>
                </div>
                <div className="flex items-start" data-id="element-529">
                  <div className="flex-shrink-0 mt-1" data-id="element-530">
                    <CheckCircleIcon className="h-5 w-5 text-blue-600 dark:text-brand-green" data-id="element-531" />
                  </div>
                  <p className="ml-3 text-gray-700 dark:text-gray-300" data-id="element-532">
                    Full transaction tracking and reporting
                  </p>
                </div>
              </div>
            </div>
            <div className="flex justify-center" data-id="element-533">
              <div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800 p-8 rounded-lg shadow-md max-w-md" data-id="element-534">
                <div className="space-y-4" data-id="element-535">
                  <div className="flex items-center justify-between border-b border-gray-200 dark:border-gray-700 pb-4" data-id="element-536">
                    <div data-id="element-537">
                      <h3 className="font-medium text-gray-900 dark:text-white" data-id="element-538">
                        iPhone 13 Pro Max
                      </h3>
                      <p className="text-sm text-gray-500 dark:text-gray-400" data-id="element-539">
                        128GB - Graphite
                      </p>
                    </div>
                    <div className="text-xl font-bold text-blue-600 dark:text-brand-green" data-id="element-540">
                      $549
                    </div>
                  </div>
                  <div className="space-y-2" data-id="element-541">
                    <div className="flex justify-between" data-id="element-542">
                      <span className="text-gray-500 dark:text-gray-400" data-id="element-543">
                        Device Condition
                      </span>
                      <span className="font-medium text-gray-900 dark:text-white" data-id="element-544">
                        Good
                      </span>
                    </div>
                    <div className="flex justify-between" data-id="element-545">
                      <span className="text-gray-500 dark:text-gray-400" data-id="element-546">
                        Battery Health
                      </span>
                      <span className="font-medium text-gray-900 dark:text-white" data-id="element-547">
                        86%
                      </span>
                    </div>
                    <div className="flex justify-between" data-id="element-548">
                      <span className="text-gray-500 dark:text-gray-400" data-id="element-549">
                        IMEI Status
                      </span>
                      <span className="text-blue-600 dark:text-brand-green font-medium" data-id="element-550">
                        Clean
                      </span>
                    </div>
                  </div>
                  <Button className="w-full bg-blue-600 dark:bg-brand-green hover:bg-blue-700 dark:hover:bg-brand-green/90 text-white dark:text-black" data-id="element-551">
                    Accept Offer
                  </Button>
                  <button className="w-full text-blue-600 dark:text-brand-green text-sm" data-id="element-552">
                    See Detailed Report
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}
function ComponentStatus({
  icon,
  name,
  status,
  detail
}) {
  const getStatusColor = status => {
    switch (status) {
      case 'passed':
        return 'text-green-500';
      case 'warning':
        return 'text-yellow-500';
      case 'failed':
        return 'text-red-500';
      default:
        return 'text-gray-500 dark:text-gray-400';
    }
  };
  const getStatusIcon = status => {
    switch (status) {
      case 'passed':
        return <CheckIcon className="h-4 w-4" data-id="element-553" />;
      case 'warning':
        return <AlertTriangleIcon className="h-4 w-4" data-id="element-554" />;
      case 'failed':
        return <XCircleIcon className="h-4 w-4" data-id="element-555" />;
      default:
        return null;
    }
  };
  return <div className="bg-white dark:bg-gray-800 rounded-lg p-3 flex flex-col items-center border border-gray-200 dark:border-gray-700" data-id="element-556">
      <div className={`${getStatusColor(status)}`} data-id="element-557">{icon}</div>
      <div className="text-gray-700 dark:text-gray-300 text-sm mt-1" data-id="element-558">
        {name}
      </div>
      <div className={`flex items-center mt-1 ${getStatusColor(status)}`} data-id="element-559">
        {getStatusIcon(status)}
        <span className="text-xs ml-1" data-id="element-560">{detail || status}</span>
      </div>
    </div>;
}